//store
import * as PaymentStore from "../../../../redux/middleware/CashFlow-Payments.Middlerware";
import * as PersonsStore from "../../../../redux/middleware/Persons.Middleware";

// models
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { Debt } from "../../../../models/Entities/CashFlow/Debt/Debt";
import { ErrorType } from "../../../../models/HttpError";
import { AppState } from "../../../../redux/reducers";

import * as jwt_decode from "jwt-decode";
import { Person } from "../../../../models/Entities/Person/Person";

// form types
export enum FormType {
  payer =1,
  receiver = 2
}

//#region Props

interface IProps {
    /** receiver: el centro cobra. payer: el centro paga. */
    FormType: FormType;
    ReferalId: string | undefined;
    FixedAssociatedEntityIdentifier: string | undefined;
    PaymentId?: number;
    /** Deuda desde la que se registra el cobro/pago: precarga contraparte, moneda, importe e imputación. */
    PrefillDebtId?: number;
    /** Deudas a precargar como objetos (una o varias), para pantallas donde la lista de caja no está cargada. */
    PrefillDebtsData?: Debt[];
    /** Contraparte para arrancar ya elegida. */
    PrefillCounterpartId?: string;
    isOpen: boolean;
    onClose: () => void;
  }

  interface ConnectedProps {
    isSaving: boolean;
    isSaved: boolean | undefined;
    failOnSaving: boolean;
    error: ErrorType | undefined;

    CurrentPayment: Payment | undefined;
    OwnerId: string;
    FixedCounterpart: Person | undefined;
    Persons: Person[];
    /** Deudas que este movimiento puede cancelar (a cobrar si es cobro, a pagar si es pago). */
    CandidateDebts: Debt[];
    PrefillDebt: Debt | undefined;
    /** Todas las deudas precargadas; la primera define contraparte y moneda. */
    PrefillDebts: Debt[];
    AllDebts: Debt[];
    AllPayments: Payment[];
    NameOf: (identifier: string | undefined) => string;
  }

  interface DispatchProps {
    GetPaymentById: typeof PaymentStore.actionCreators.GetPaymentById;
    CreatePayment: typeof PaymentStore.actionCreators.CreatePayment;
    UpdatePayment: typeof PaymentStore.actionCreators.UpdatePayment;
    GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
  }

  export type Props = IProps & ConnectedProps & DispatchProps;

export const GetPersonByIdentifier = (persons: Person[], tenantId: string, identifier: string): Person | undefined => {
    if (!identifier) return undefined;
    if (identifier === tenantId) return { personIdentifier: tenantId, businessName: 'Centro Médico' } as Person;
    return persons.find((person: Person) => person.personIdentifier === identifier);
};

  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const done: Payment[] = state?.CashFlowPayments?.paymentsDone || [];
    const received: Payment[] = state?.CashFlowPayments?.paymentsReceived || [];
    const currentPayment = ownProps.PaymentId
        ? (ownProps.FormType === FormType.payer ? done : received).find((payment: Payment) => payment.id === ownProps.PaymentId)
            ?? [...done, ...received].find((payment: Payment) => payment.id === ownProps.PaymentId)
        : undefined;

    const currentOwner: string = (jwt_decode.jwtDecode(state?.oidc?.user?.access_token!) as any)?.tenantId;
    const persons = state.Persons?.list || [];
    const asCreditor: Debt[] = state.CashFlowDebts?.DebtsAsCreditor || [];
    const asDebtor: Debt[] = state.CashFlowDebts?.DebtsAsDebtor || [];
    const stored = ownProps.FormType === FormType.receiver ? asCreditor : asDebtor;
    const byId = ownProps.PrefillDebtId ? stored.find((debt) => debt.id === ownProps.PrefillDebtId) : undefined;
    const prefillList: Debt[] = ownProps.PrefillDebtsData ?? (byId ? [byId] : []);
    // Las deudas precargadas entran aunque la lista de caja no las tenga todavía.
    const missing = prefillList.filter((debt) => !stored.some((item) => item.id === debt.id));
    const candidates = missing.length > 0 ? [...stored, ...missing] : stored;

    return ({
        isSaving: currentPayment ? !!(currentPayment.isUpdating || currentPayment.isSaving) : state.CashFlowPayments?.isAddingNewOne || false,
        isSaved: currentPayment ? (currentPayment.isUpdatedSuccessfully || currentPayment.isSavedSuccessfully) : state.CashFlowPayments?.successAddingNewOne || undefined,
        failOnSaving: currentPayment ? !!(currentPayment.failOnUpdating || currentPayment.failOnSaving) : state.CashFlowPayments?.failOnAddingNewOne || false,
        error: state.CashFlowPayments?.error || currentPayment?.error || undefined,

        CurrentPayment: currentPayment,
        OwnerId: currentOwner,
        FixedCounterpart: GetPersonByIdentifier(persons, currentOwner, ownProps.FixedAssociatedEntityIdentifier || ''),
        Persons: persons,
        CandidateDebts: candidates,
        PrefillDebt: prefillList[0],
        PrefillDebts: prefillList,
        AllDebts: [...asCreditor, ...asDebtor],
        AllPayments: [...received, ...done],
        NameOf: (identifier: string | undefined) => GetPersonByIdentifier(persons, currentOwner, identifier || '')?.businessName || identifier || '—'
    })
  };

  export const mapDispatchToProps = {
    GetPaymentById: PaymentStore.actionCreators.GetPaymentById,
    CreatePayment: PaymentStore.actionCreators.CreatePayment,
    UpdatePayment: PaymentStore.actionCreators.UpdatePayment,
    GetAllPersons: PersonsStore.actionCreators.GetAllPersons
  };
